import React from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

import { normalizeURL } from 'helpers/urls';
import { useAppSelector } from 'store/hook';
import { CommunityAdminListType } from 'types/communities';

const Container = styled.span`
  display: flex;
  flex-direction: column;
  margin: 2px 0px 10px 0px;
`;

const Main = styled.span`
  font-family: var(--font-bold);
  font-size: 14px;
  color: var(--dark-blue);
  &.active {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Secondary = styled.span`
  font-size: 12px;
  color: var(--text-primary);
`;

interface Props {
  item: CommunityAdminListType;
}

const CommunitiesTableCommunity = ({ item }: Props) => {
  const { currentUser } = useAppSelector((state) => state.auth);

  const viewCommunity = () => {
    window.open(`/communities/${item.id}/info`, '_blank');
  };

  return (
    <Container>
      <Main
        className={classNames({ active: currentUser?.isSuperuser })}
        onClick={currentUser?.isSuperuser ? viewCommunity : undefined}
      >
        {item?.comunity_name}
      </Main>
      <Secondary>{normalizeURL(item?.website)}</Secondary>
      <Secondary>{item?.phone_number}</Secondary>
    </Container>
  );
};

export default CommunitiesTableCommunity;
